import React, { Fragment } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

const ServicesListActions = ({ data, preAddItemService }) => {

    const addArticleManualInvoice = () => {
        if (typeof preAddItemService != 'undefined') {
            preAddItemService(data.data.original);
        }
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Agregar Servicio">
                <IconButton style={{ fontSize: '15px' }} onClick={() => addArticleManualInvoice()}>
                    <FontAwesomeIcon icon={faPlus} />
                </IconButton>
            </Tooltip>
        </td>

    </Fragment>)
}

export default ServicesListActions;